/**
 * 获取页面参数
 * - 微信授权的参数
 *    code // 微信授权参数
 *    copyCode // 失败时复制参数
 *    state // 授权时携带的状态
 * - 分享
 * - 接口请求
 */
let _args = null

const getArgs = () => {
  let qs = location.search.length > 0 ? location.search.substring(1) : ''
  const args = {}
  qs = qs.replace('&amp;', '&').replace('?', '')
  const items = qs.length ? qs.split('&') : []
  items.forEach(function(e, index) {
    const item = e.split('=')
    args[decodeURIComponent(item[0]).trim()] = decodeURIComponent(item[1] || '')
  })
  return args
}

const parseArgs = (args) => {
  // port: module.env
  const portArg = args.port || ''
  const port = {}
  portArg.split(',').map(m => {
    const v = m.split('.')
    const [key, value] = [v[0], v[1]]
    if (key) {
      if (value) {
        // 模块的环境
        port[key] = value
      } else {
        // 默认环境
        port['default'] = key
      }
    }
  })
  args.port = port
  return args
}

export const pageArgs = {
  args() {
    if (_args) return _args
    // 读取页面参数
    _args = parseArgs(getArgs())
    return _args
  }
}

window.pageArgs = pageArgs
export default pageArgs
